/* eslint-disable react-hooks/exhaustive-deps */
import {
  Background,
  Layout,
  TextWrapper,
} from "styles/components/common/ProfileStyle";
import { ButtonSolid } from "styles/common/ButtonStyle";
import earth from "assets/images/earth.png";
import useAuthStore from "store/auth";
import { getProfile } from "api/user";
import { useEffect } from "react";

const today = new Date().toLocaleDateString("ko-KR", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

function Profile() {
  const authStore = useAuthStore();
  const userInfo = authStore?.user;
  const usageText = `${userInfo?.usevolume?.toLocaleString() || 0}mL`;
  const amountText = `${userInfo?.useamt?.toLocaleString() || 0}원`;
  const fetchProfile = async () => {
    try {
      const { useamt, usevolume } = await getProfile();
      authStore.setUser({
        ...userInfo,
        useamt,
        usevolume,
      });      
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <Background>
      <Layout>
        <TextWrapper>
          <span className="label">{today}</span>
          <span className="user-name">{userInfo?.alias} 님</span>
          <div className="value-wrapper">
            <div className="usage">
              <span className="label">누적 사용량</span>
              {/* <span className="value">{usageText}</span> */}
              <span className="value">{usageText}</span>
            </div>
            <div className="amount">
              <span className="label">누적 금액</span>
              <span className="value">{amountText}</span>
            </div>
          </div>
          <ButtonSolid onClick={fetchProfile}>새로고침</ButtonSolid>
        </TextWrapper>
        <img src={earth} alt="earth" className="earth" />
      </Layout>
    </Background>
  );
}

export default Profile;
